var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"LyFZzdFijk-g2D3kJy3Jo"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  // dsn: process.env.sentryDsn,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  replaysOnErrorSampleRate: 0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
    // The following is all you need to enable canvas recording with Replay
    Sentry.replayCanvasIntegration(),
    Sentry.captureConsoleIntegration(),
    Sentry.extraErrorDataIntegration({ depth: 5, captureErrorCause: true }),
    // Once this integration is active, every event captured by Sentry will include session timing information.
    Sentry.sessionTimingIntegration(),
    // This integration captures errors on failed requests from Fetch and XHR and attaches request and response information.
    Sentry.httpClientIntegration(),
    // When an error occurs, this metadata helps identify exactly which module and team are responsible
    Sentry.moduleMetadataIntegration(),
    // reports browser observer captured message for example older APIs that are slated for deprecation
    Sentry.reportingObserverIntegration()
  ],

  // This option is required for capturing headers and cookies.
  sendDefaultPii: true,
});
